<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div>
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column prop="title" label="会员等级"></el-table-column>
              <el-table-column prop="point" label="会员点数"></el-table-column>
              <el-table-column prop="discount" label="会员折扣(例：0.95为95折)"></el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <el-dialog
        title="会员操作"
        :visible.sync="boolAddNew"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">会员名称</div>
          <el-input
            style="display:inline-block;width:70%;"
            v-model="form.title"
          ></el-input>
        </div>
        <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">会员点数</div>
          <el-input
            type="number"
            :min="0"
            style="display:inline-block;width:70%;"
            v-model="form.point"
          ></el-input>
        </div>
    <div style="margin-top:20px;">
          <div style="display:inline-block;text-align:left;width:10%;">会员折扣</div>
          <el-input
            type="number"
            :min="0"
            style="display:inline-block;width:70%;"
            v-model="form.discount"
          ></el-input>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "adModify",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,

      form: {
        title: "",
        point: "",
        discount: ""
      },
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },
   
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchMemberInfo", {})
        .then((res) => {
          this.fullscreenLoading = false;
          this.tableDataList = res.data.data;
        });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        title: "",
        point: "",
        discount: ""

      };
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        title: this.currentData.title,
        point: this.currentData.point,
        discount: this.currentData.discount,
      };
    },
    onEditConfirm() {
      if (this.form.title == "" || this.form.point == '' || this.form.discount == '') {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminUpdateMemberInfo", {
          id: this.currentData.id,
          title: this.form.title,
          point: this.form.point,
          discount: this.form.discount,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

  


    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditOpen();
          break;
      }
    },

  },
};
</script>

